import { TRANSACTIONS } from '../actionTypes';

export const fetchTransactions = (action) => ({
  type: TRANSACTIONS.FETCH,
  payload: action.payload,
});
